import React, { useState, useEffect } from 'react';
import { Empty, Button, Pagination, Checkbox, Space, Dropdown, Menu, Input, Divider, Badge, Select } from 'antd';
import {
  UserOutlined,
  PlusOutlined,
  CaretDownOutlined,
  UnorderedListOutlined,
  DeleteOutlined,
  DownOutlined,
  UpOutlined,
  CheckCircleFilled,
  ImportOutlined,
  WarningOutlined,
  EditOutlined,
  FilterOutlined,
  CaretUpOutlined, SearchOutlined
} from '@ant-design/icons';

import './style';

export default React.forwardRef((props, ref) => {
  const { onNew, onDelete, onEdit, body, title, rows, footer, selectable } = props;

  const [selected, setSelected] = useState(0);
  useEffect(() => {

  }, []);

  const onSelectAll = () => {

  }

  const onSelectRow = (index) => {

  }


  return (
    <div className="panel-container">
      {
        title && <div className="panel-container header">
          <div className="title">{title}</div>
        </div>
      }
      {
        body && (
          <div className="panel-container body">{body}</div>
        )
      }
      {
        footer && <div className="list-container-footer">
          共{rows.length}项
      </div>
      }
    </div>
  );
});
